// extracted by mini-css-extract-plugin
export default {"DataBox":"IosAdnetwork_DataBox__3nSpB","firstAdsflatform":"IosAdnetwork_firstAdsflatform__twgc-"};